import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule, PipesModule } from '@fcom/common';
import { CmsModule } from '@fcom/cms';

import { DapiIncludedProductsComponent } from './included-products/included-products.component';
import { DapiIncludedServiceComponent } from './included-service/included-service.component';
import { DapiIncludedProductItemComponent } from './included-product-item/included-product-item.component';
import { DapiIncludedProductHeadingComponent } from './included-product-heading/included-product-heading.component';
import { DapiIncludedTicketsComponent } from './included-tickets/included-tickets.component';
import { IncludedBoundFlightsHeadingComponent } from './included-bound-flights-heading/included-bound-flights-heading.component';
import { UpsellCardComponent } from './upsell-card/upsell-card.component';
import { GroupedServicesComponent } from './grouped-services/grouped-services.component';
import { InformationModalComponent } from './information-modal/information-modal.component';
import { IncludedProductItemSummaryComponent } from './included-product-item-summary/included-product-item-summary.component';
import { IncludedProductItemSummarySeatComponent } from './included-product-item-summary-seat/included-product-item-summary-seat.component';
import { IncludedProductItemSummaryOtherComponent } from './included-product-item-summary-other/included-product-item-summary-other.component';
import { IncludedProductItemSummaryCheckedBagComponent } from './included-product-item-summary-checked-bag/included-product-item-summary-checked-bag.component';

const COMPONENTS = [
  DapiIncludedProductHeadingComponent,
  DapiIncludedProductsComponent,
  DapiIncludedProductItemComponent,
  IncludedProductItemSummaryComponent,
  IncludedProductItemSummarySeatComponent,
  IncludedProductItemSummaryCheckedBagComponent,
  IncludedProductItemSummaryOtherComponent,
  DapiIncludedServiceComponent,
  DapiIncludedTicketsComponent,
  IncludedBoundFlightsHeadingComponent,
  UpsellCardComponent,
  GroupedServicesComponent,
  InformationModalComponent,
];

@NgModule({
  imports: [CommonModule, PipesModule, UiTranslateModule, UiComponentsModule, ComponentsModule, CmsModule],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  providers: [],
})
export class DapiComponentsModule {
  constructor(@Optional() @SkipSelf() parentModule: DapiComponentsModule) {
    if (parentModule) {
      throw new Error('DapiComponentsModule is already loaded. Import in your base AppModule only.');
    }
  }
}
